import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d7da8ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Prompt Elements", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "list-row" }
const _hoisted_4 = {
  key: 0,
  class: "separator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePromptElement = _resolveComponent("BasePromptElement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("ol", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: element.name
        }, [
          (_ctx.separate(element))
            ? (_openBlock(), _createElementBlock("li", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createVNode(_component_BasePromptElement, {
              label: element.name,
              tooltip: element.description,
              onClick: ($event: any) => (_ctx.pushToPrompt(index))
            }, null, 8, ["label", "tooltip", "onClick"])
          ])
        ], 64))
      }), 128))
    ])
  ], 64))
}